import { post } from "@libs:axios";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { CamelCasedPropertiesDeep } from "type-fest/source/camel-cased-properties-deep";

import { BotTasksGetSchema, TranscribeApiAudioPostData } from "@:openapi";

export interface Audio {
  POST: {
    RequestQuery: CamelCasedPropertiesDeep<TranscribeApiAudioPostData["query"]>;
    RequestBody: CamelCasedPropertiesDeep<TranscribeApiAudioPostData["body"]>;
    Response: CamelCasedPropertiesDeep<BotTasksGetSchema>;
  };
}

export const useMutationTranscribeAudio = (
  botId: string,
  options?: UseMutationOptions<
    Audio["POST"]["Response"],
    AxiosError,
    Audio["POST"]["RequestBody"]
  >,
) => {
  return useMutation({
    mutationFn: (data: Audio["POST"]["RequestBody"]) => {
      const formData = new FormData();

      if (data.file) {
        formData.append("file", data.file);
      }

      if (data.languageCode) {
        formData.append("language_code", data.languageCode);
      }

      if (data.numSpeakers) {
        formData.append("num_speakers", data.numSpeakers.toString());
      }

      return post<Audio["POST"]["Response"]>("/api/audio", formData, {
        params: {
          botId,
        },
      });
    },
    ...options,
  });
};
